import {Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {PartsService} from '../../../Services/parts.service';
import {Part} from '../../../Models/Part';
import {Observable, Subject} from 'rxjs';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import { NgForm } from '@angular/forms';
import { createPartsOverviewGridConfig } from '../configs';

@Component({
  selector: 'app-parts-overview',
  templateUrl: './parts-overview.component.html',
  styleUrls: ['./parts-overview.component.scss']
})
export class PartsOverviewComponent implements OnInit {
  public grid: Grid;
  public partId: number;
  public partName: string;
  public parts: Observable<Part[]>;
  public partsLoading = false;
  public partsinput$ = new Subject<string>();
  public newStocksForPart: number = 0;
  public totalStockAmount: number = 0;
  public viewPartData: Part = null;
  @ViewChild('partRowDetail', {static: false}) partRowDetail: TemplateRef<any>;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('addStockModal', {static: false}) addStockModal = null;
  @ViewChild('addStockForm', {static: false}) addStockForm: NgForm;
  @ViewChild('viewModal', {static: false}) viewModal = null;
  
  constructor(
    private router: Router, 
    private partsService: PartsService, 
    private broadcastService: BroadcastService,
  ) {}

  ngOnInit() {
    this.grid = createPartsOverviewGridConfig(
      this.router,
      this.partsService,
      this.partRowDetail,
      this.onEditPart.bind(this),
      this.onDeletePart.bind(this),
      this.onAddStockPart.bind(this),
      this.onViewPart.bind(this)
    );
  }

  private onEditPart(row: Part) {
    return this.router.navigateByUrl('back-office/parts/' + row.id);
  }

  private onDeletePart(row: Part) {
    this.partId = row.id;
    this.partName = row.name.bold();
    this.deleteModal.show();
  }

  private onAddStockPart(row: Part) {
    this.partId = row.id;
    this.totalStockAmount = row.stockAmount;
    this.addStockForm.reset();
    this.addStockModal.show();
  }

  private onViewPart(row: Part) {
    this.viewPartData = row;
    this.viewModal.show();
  }

  public editPart() {
    this.router.navigateByUrl('back-office/parts/' + this.viewPartData.id);
  }

  public addStockValue(form: NgForm) {
    const newStockAmount = this.totalStockAmount + form.value.newStocksForPart;
    this.partsService.addStockToPart({stockAmount: newStockAmount}, this.partId).subscribe(() => {
      this.addStockModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getPart');
    });
  }

  public softDelete() {
    this.partsService.softDeletePart(this.partId).subscribe(() => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getPart');
    });
  }

  goToArchive() {
    this.router.navigateByUrl('back-office/parts/archive');
  }
}
